import React, { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { SELECT_DATA_FOR_ORDER_PACKAGE } from "../../../../../../../store/actions/actionsTypes";
import { ITableOfTableItem } from "../../../../../../modules/API/Defaults/models/tableOfTables";
import { Drivers } from "../../../../../../modules/API/Drivers/drivers";
import {
  ICustomerItem,
  IKavDataItem,
} from "../../../../../../modules/API/Drivers/models/kavData";
import { applyPackageAction } from "../../helpers/driversState";

export interface IUsePackageOrder {
  isOpenPortalModal: boolean;
  isOpenPackageOverlay: boolean;
  handlePortalModal: () => void;
  handleIsOpenPackageOverlay: () => void;
  selectDataForPackageOrder: (
    dataCustomer: ICustomerItem,
    kavID: number
  ) => void;
  saveToLogPackage: (action: number, areaID?: number) => Promise<void>;
  portalModalProps: object;
}

export const usePackageOrder = (deps: {
  data: IKavDataItem[] | null;
  setData: React.Dispatch<React.SetStateAction<IKavDataItem[] | null>>;
  date: string;
  customerData: ICustomerItem | undefined;
  setCustomerData: (customer: ICustomerItem) => void;
  isOffice: boolean;
  listPacakgesActions: ITableOfTableItem[] | undefined;
}): IUsePackageOrder => {
  const {
    data,
    setData,
    date,
    customerData,
    setCustomerData,
    isOffice,
    listPacakgesActions,
  } = deps;
  const dispatch = useDispatch();

  const [isOpenPortalModal, setIsOpenPortalModal] = useState(false);
  const [isOpenPackageOverlay, setIsOpenPackageOverlay] = useState(false);

  const handlePortalModal = useCallback(() => {
    setIsOpenPortalModal((prev) => !prev);
  }, []);

  const handleIsOpenPackageOverlay = useCallback(() => {
    setIsOpenPortalModal(false);
    setIsOpenPackageOverlay((prev) => !prev);
  }, []);

  const selectDataForPackageOrder = useCallback(
    (dataCustomer: ICustomerItem, kavID: number) => {
      setCustomerData(dataCustomer);
      const collection = {
        carID: data ? data[0].CarId : 0,
        sender: dataCustomer.ClientID,
        reference: dataCustomer.Orders[0]?.Delivery_Num || "",
        date: date,
        clientName: dataCustomer.Customer_Name?.trim(),
        isReverseSender: dataCustomer?.Type === 1,
        finalFunc: undefined,
        customerID: dataCustomer.CustomerID,
        TransferZone: kavID,
      };
      dispatch({ type: SELECT_DATA_FOR_ORDER_PACKAGE, payload: collection });
      setIsOpenPortalModal(true);
    },
    [data, date, dispatch, setCustomerData]
  );

  const saveToLogPackage = useCallback(
    // areaID приходит undefined: PackagesPortalModal зовёт saveAction(action)
    // одним аргументом. Легаси-поведение — TransferZone уходит нулём.
    async (action: number, areaID?: number) => {
      const postData = {
        Action: action,
        ActionTblCode: 129,
        Delivery_Date: date,
        PersonID: customerData?.CustomerID || 0,
        PersonType: customerData?.Type || 0,
        ReferenceId: customerData?.PO_Num || 0,
        ReferenceType: 2,
        TransferZone: areaID || 0,
      };
      try {
        await Drivers.logStatusDelivery([postData]);
        setIsOpenPortalModal(false);
        if (action !== 1) {
          const description =
            listPacakgesActions?.find((e) => e.SecondCode === action)
              ?.Description || "";
          setData((prev) =>
            prev
              ? applyPackageAction(
                  prev,
                  customerData?.CustomerID,
                  action,
                  description
                )
              : prev
          );
        }
      } catch {
        // легаси молча проглатывал ошибку
      }
    },
    [date, customerData, listPacakgesActions, setData]
  );

  const portalModalProps = useMemo(
    () => ({
      customerData: customerData,
      openPackageOverlay: handleIsOpenPackageOverlay,
      list: listPacakgesActions,
      saveAction: saveToLogPackage,
      isOffice: isOffice,
    }),
    [
      customerData,
      handleIsOpenPackageOverlay,
      listPacakgesActions,
      saveToLogPackage,
      isOffice,
    ]
  );

  return {
    isOpenPortalModal,
    isOpenPackageOverlay,
    handlePortalModal,
    handleIsOpenPackageOverlay,
    selectDataForPackageOrder,
    saveToLogPackage,
    portalModalProps,
  };
};

export default usePackageOrder;
